import React, { useState, useEffect } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import { API } from '../../../API/API';
import PageHeader from '../../../components/PageHeader/PageHeader';

const FamilyReport = (props) => {

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);

    const [columns] = useState([
        {
            name: 'Ажилтны овог',
            fieldName: 'emplastname',
            colSize: 'mid'
        },
        {
            name: 'Ажилтны нэр',
            fieldName: 'empfirstname',
            colSize: 'mid'
        },
        {
            name: 'Дотоод нэгж',
            fieldName: 'departmentname'
        },
        {
            name: 'Ажлын байр',
            fieldName: 'positionname'
        },
        {
            name: 'Хэн болох',
            fieldName: 'relativename'
        }, {
            name: 'Овог',
            fieldName: 'lastname'
        }, {
            name: 'Нэр',
            fieldName: 'firstname'
        }, {
            name: 'Төрсөн огноо',
            fieldName: 'birthdate'
        }, {
            name: 'Төрсөн аймаг, хот',
            fieldName: 'divisionname'
        }, {
            name: 'Төрсөн сум, дүүрэг',
            fieldName: 'districtname'
        }, {
            name: 'Регистрийн дугаар',
            fieldName: 'famregno'
        }, {
            name: 'Хүйс',
            fieldName: 'empgendername'
        }
    ]);

    const [loading, setLoading] = useState(false);

    const getData = async () => {
        setLoading(true);
        let tData = [];

        await API.get('/api/humanresource/report/get_emp_family_report').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });

        setData(tData);
        setOData(tData);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                title='Гэр бүл'
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default FamilyReport;